import { MediaPackageCatalog } from '../components/MediaPackageCatalog';

/**
 * Effect side of the .tfx catalog — every package the CDN serves that does NOT
 * carry the transition cap, whichever channel published it.
 *
 * <p>This replaces the old published-catalog view, which listed only the rows
 * this portal published (a handful) and so could neither show nor take down the
 * packages the offline factory publishes — the great majority of the catalog.
 */
export function EffectCatalogPage() {
  return (
    <MediaPackageCatalog
      kind="EFFECT"
      title="Effect Catalog"
      emptyMessage="No effect packages match this filter."
    />
  );
}
